import _ from 'underscore';

export const createFolderFilterQuery = ({
  searchTerm,
  minWidth,
  minHeight,
  minVideoDuration,
  maxVideoDuration,
  dateAddedStart,
  dateAddedEnd,
  assetType,
  sourceType,
  assetSources,
  folderId,
  hasPerfData,
  topRated,
}) => {
  const filterPredicates = [];

  if (assetType) {
    filterPredicates.push(`FolderAssetType eq '${assetType}'`);
  }
  if (minWidth) {
    filterPredicates.push(`Width gt ${minWidth}`);
  }
  if (minHeight) {
    filterPredicates.push(`Height gt ${minHeight}`);
  }

  if (minVideoDuration) {
    filterPredicates.push(`VideoDuration gt ${minVideoDuration}`);
  }
  if (maxVideoDuration) {
    filterPredicates.push(`VideoDuration lt ${maxVideoDuration}`);
  }

  if (dateAddedStart && dateAddedEnd && dateAddedStart === dateAddedEnd) {
    filterPredicates.push(`CreatedTime eq ${dateAddedStart}`);
  } else {
    if (dateAddedStart) {
      filterPredicates.push(`CreatedTime ge ${dateAddedStart}`);
    }
    if (dateAddedEnd) {
      filterPredicates.push(`CreatedTime le ${dateAddedEnd}`);
    }
  }
  if (sourceType) {
    filterPredicates.push(`SourceType eq '${sourceType}'`);
  }
  if (!_.isEmpty(assetSources)) {
    filterPredicates.push(`AssetSourceType in (${assetSources.map(s => `'${s}'`).join(',')})`);
  }
  if (searchTerm) {
    filterPredicates.push(`contains(BroadSearchFields, '${searchTerm}')`);
  }

  if (folderId) {
    filterPredicates.push(`FolderId eq ${folderId}`);
  }

  if (hasPerfData) {
    filterPredicates.push('PerformanceMetrics/Impressions gt 0');
  }

  if (topRated) {
    filterPredicates.push("AssetPerformanceRating eq 'Best'");
  }

  const filterQuery = filterPredicates.length > 0 ?
    `${filterPredicates.join(' and ')}` : '';

  return filterQuery ? `$filter=${filterQuery}` : '';
};
